import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMediaQuery } from '@mui/material';
import { memo } from 'react';
import { NotificationContent, TextWrapper, RoomModalContent, } from '../ImageSizeAlert/styled';
import { modalStore, roomModalStore } from '@/shared/model/modal';
import TextElement from '@/shared/ui/TextElement';
import ButtonCustom from '@/shared/ui/ButtonCustom';
const handleClose = () => {
    modalStore.close();
    roomModalStore.close();
};
const InnerGoogleAuthErrorModal = ({ title, description }) => {
    const isMobileSize = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    return (_jsx(RoomModalContent, { children: _jsxs(NotificationContent, { children: [_jsxs(TextWrapper, { children: [_jsx(TextElement, { fontSize: isMobileSize ? 20 : 24, fontWeight: 600, textAlign: 'start', component: "h6", children: title }), _jsx(TextElement, { fontSize: isMobileSize ? 14 : 16, textAlign: 'start', children: description })] }), _jsx(ButtonCustom, { fontSize: isMobileSize ? 14 : 16, variant: 'contained', onClick: handleClose, height: 48, width: 162, children: "Ok, got it" })] }) }));
};
export const GoogleAuthErrorModal = memo(InnerGoogleAuthErrorModal);
